<template>
  <div>
    <!-- <div style="display: flex; justify-content: space-between; margin: 20px 10px">
      <div style="display: flex">
        <span style="word-break: keep-all; display: flex; justify-content: center; align-items: center">发起人：</span>
        <sw-input
          v-model.trim="applyName"
          placeholder="请输入"
        />
      </div>

      <div style="display: flex">
        <span style="word-break: keep-all; display: flex; justify-content: center; align-items: center">发起时间：</span>
        <el-date-picker
          v-model="applyTime"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        />
      </div>
      <div>
        <sw-button @click="resetTableData">重置</sw-button>
        <sw-button
          type="primary"
          @click="getTableData"
        >查询</sw-button>
      </div>
    </div> -->
    <div style="display:flex; justify-content: space-between; margin:10px 10px">
      <div>
        <sw-button
          icon="su-icon-plus"
          type="primary"
          @click="handleAddData"
        >新增</sw-button>
        <sw-button
          icon="su-icon-search"
          type="primary"
          @click="handleAdvancedSearch"
        >高级查询</sw-button>
        <sw-button
          icon="su-icon-search"
          type="primary"
          @click="handleBatchDownload"
        >批量下载</sw-button>
      </div>
      <div>
        <sw-button
          v-if="isDice"
          type="primary"
          @click="openLink"
        >接口配置</sw-button>
        <!-- <sw-button type="primary">列表设计</sw-button> -->
        <sw-button
          type="warning"
          @click="handleShareClick"
        >数据分享</sw-button>
        <sw-button
          type="success"
          @click="handleExportClick"
        >导出Excel</sw-button>
      </div>
    </div>
    <div>
      <sw-table
        v-loading="tableLoading"
        v-if="showTable"
        :key="tableKey"
        :table-name="'data-manage'"
        :table-data="tableData"
        :table-title="tableTitle"
        :page-sizes="[10, 20, 50, 100]"
        :total-count="totalCount"
        :page-size="pageSize"
        :page-index="page"
        :has-add-button="false"
        :table-operation="tableOperation"
        :conflict-operation="conflictOperation"
        @selection-change="changeSelection"
        @change-page="changePage"
        @size-change="changeSize"
        @operation-handle="operationHandle"
      >
        <template
          slot="customcolumn"
          slot-scope="scope"
        >
          <span v-if="scope.item.type == 'table'">
            <sw-button @click="openSonTable(scope)">子表单</sw-button>
          </span>
          <span
            v-else
            :title="
              scope.row[scope.item.prop] ? scope.row[scope.item.prop] : '-'
            "
            class="swTableCell"
          >
            {{ scope.row[scope.item.prop] ? scope.row[scope.item.prop] : "-" }}
          </span>
        </template>
      </sw-table>
    </div>
    <sw-dialog
      :visible.sync="dialogTableVisible"
      :title="dialogTableComment"
    >
      <el-table :data="dialogTableData">
        <el-table-column
          v-for="item in dialogTableHeader"
          :key="item.name"
          :property="item.name"
          :label="item.comment"
        />
      </el-table>
    </sw-dialog>
    <sw-slide-dialog
      :visible.sync="dataShareObj.dialogFlag"
      :width="'648px'"
      title="数据分享"
    >
      <div>
        <sw-transfer
          v-loading="dataShareObj.listLoading"
          :data-config="{label:'title',value:'value',describe:'describe', disabled:'disabled',}"
          :list="dataShareObj.list"
          :selected="dataShareObj.selected"
          :pagination="false"
          :search="false"
          :search-condition="[{name:'userName',value: dataShareObj.keyword}]"
          :lazy="dataShareObj.hasMore"
          height="calc(100vh - 144px)"
          option-label="可选用户"
          @loadmore="getUserList"
          @change="handleTransferChange"
        >
          <template slot="expansionSearch">
            <div>
              <el-input
                v-model.trim="dataShareObj.keyword"
                placeholder="请输入用户名/ID"
              />
            </div>
          </template>
        </sw-transfer>
      </div>
      <span slot="footer">
        <sw-button
          size="small"
          @click="dataShareObj.dialogFlag= false"
        >取 消</sw-button>
        <sw-button
          size="small"
          type="primary"
          @click="confirmShare"
        >确 定</sw-button>
      </span>
    </sw-slide-dialog>
    <sw-drawer
      :visible.sync="advancedDrawer.visible"
      title="高级查询"
      direction="rtl"
    >
      <AdvancedSearch
        :is-show="true"
        :yyid="$route.query.yyid"
        :type="'resultSearch'"
        class="innerSearch"
        @condition="handleGetCondition"
      />
    </sw-drawer>
    <sw-dialog
      :visible.sync="excelVisible"
      title="导出Excel"
    >
      <el-form label-width="180px">
        <el-form-item label="筛选发起时间">
          <el-date-picker
            v-model="applyTime"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <sw-button @click="excelVisible = false">取 消</sw-button>
        <sw-button
          type="primary"
          @click="handleExportConfirm"
        >确 定</sw-button>
      </span>
    </sw-dialog>
  </div>
</template>
<script>
import service, { designFormUrl, baseURL } from '@/utils/service'
import JSONService from '@/utils/JSONService'
import { parseTime } from '@/utils/index.js'
import AdvancedSearch from './components/AdvancedSearch'
import { getDataviewInfo } from './components/fill'
export default {
  components: {
    AdvancedSearch
  },
  data () {
    return {
      tableKey: 0,
      applyName: '', // 发起人
      applyTime: [], // 发起时间
      showTable: true,
      tableLoading: false,
      page: 1,
      pageSize: 10,
      totalCount: 0,
      tableName: '',
      tableId: '',
      tableData: [],
      tableTitle: [{ prop: 'text', label: '单行文本' }],
      tableOperation: [
        { name: '查看', icon: 'su-icon-details', operation: 'details' },
        { name: '修改', icon: 'su-icon-edit', operation: 'edit' },
        { name: '删除', icon: 'su-icon-delete', operation: 'delete' }
      ],
      conflictOperation: {
        delete: { prop: 'dataType', value: ['process'] },
        edit: { prop: 'dataType', value: ['process'] },
        details: { prop: 'dataType', value: ['append'] }
      },
      dialogTableData: [],
      dialogTableHeader: [],
      dialogTableVisible: false,
      dialogTableComment: '子表',
      dataShareObj: {
        dialogFlag: false,
        listLoading: false,
        hasMore: true,
        keyword: '',
        selected: [],
        list: [],
        page: 0,
        limit: 50,
        searchListFlag: false
      },
      advancedDrawer: {
        key: 1,
        visible: false,
        search: {
          field: {
            value: '1',
            options: []
          },
          condition: {
            value: '2',
            options: []
          }
        }
      },
      condition: {},
      batchDownloadArr: [],
      excelVisible: false
    }
  },
  computed: {
    pageVisible () {
      return this.$store.state.appflow.pageVisible
    },
    isDice () {
      return location.host.indexOf('dice') > -1
    }
  },
  watch: {
    pageVisible (val) {
      if (val) {
        // this.getTableHeader()
      }
    },
    'dataShareObj.keyword': function (newVal) {
      this.searchListLan()()
    }
  },
  created () {
    this.getDataResult(this.condition)
  },
  methods: {
    changeSelection (val) {
      this.batchDownloadArr = val
    },
    handleBatchDownload () {
      if (!this.batchDownloadArr.length) {
        this.$alert('请至少选择一条数据')
        return
      }
      const ffids = this.batchDownloadArr.map(v => {
        return v.ffid
      })
      JSONService({
        url: `/v1/file/download`,
        method: 'post',
        data: ffids,
        responseType: 'blob'
      }).then(res => {
        var blob = res.data
        if (!blob) {
          this.$$swMessage.error('数据不存在')
          return
        }
        var contentDisposition = res.headers['content-disposition']
        var filename = 'file.zip'
        if (contentDisposition && contentDisposition.indexOf('filename') > -1) {
          filename = contentDisposition.split('=')[1].trim()
          filename = JSON.parse(decodeURI(filename))
        }
        console.log(filename)
        const url = window.URL.createObjectURL(blob)
        this.download(url, filename)
      })
    },
    download (blobUrl, filename) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.download = filename
      a.href = blobUrl
      a.click()
    },
    handleGetCondition (val) {
      this.advancedDrawer.visible = false
      if ((val.orderConditions && val.orderConditions.length) || (val.queryConditions && val.queryConditions.length)) {
        this.condition = val
      } else {
        this.condition = false
      }
      this.getDataResult(val)
    },
    // 获取数据结果列表
    getDataResult (val) {
      this.tableLoading = true
      getDataviewInfo({ yyid: this.$route.query.yyid, pageIndex: this.page, pageSize: this.pageSize, condition: val }).then(res => {
        this.tableLoading = false
        this.totalCount = res.count
        if (res.data.length) {
          const tableTitle = res.data[0].father.fatherBillColumns

          let index = 0
          for (const key in res.data[0].son) {
            index++
            tableTitle.push({ name: key, comment: '子表单' + index, type: 'table' })
          }
          this.handleTableTitle(tableTitle)
          this.tableData = res.data.map((item) => {
            const line = item.father.fatherBillData

            for (const key in item.son) {
              item.son[key].header = item.son[key].childrenBillColumns
              item.son[key].data = item.son[key].childrenBillData
            }
            line.son = item.son
            for (const key in item) {
              if (!item[key]) {
                item[key] = '-'
              }
              if (key === 'createTime') {
                item[key] = parseTime(item[key])
              }
              if (!item['id']) {
                item['id'] = item.ffid
              }
            }
            return line
          })
        } else {
          this.tableData = []
          this.total = res.count
        }
      }).catch(err => {
        console.log(err)
        this.loading = false
        this.pages = {
          pageIndex: 1,
          pageSize: 10,
          total: 0
        }
      })
    },
    // 防抖函数
    searchListLan () {
      return () => {
        clearTimeout(this.timeout)
        const _this = this
        this.timeout = setTimeout(function () { // 在周期内db函数被触发会更新定时器，延迟事件函数的执行
          _this.dataShareObj.searchListFlag = true
          _this.dataShareObj.list = []
          _this.dataShareObj.page = 0
          _this.getUserList()
        }, 500)
      }
    },
    handleShareClick () {
      this.dataShareObj.keyword = ''
      this.dataShareObj.selected = []
      this.dataShareObj.dialogFlag = true
      this.dataShareObj.page = 0
      this.getUserList()
    },
    getUserList () {
      this.dataShareObj.listLoading = true
      this.dataShareObj.page++
      service
        .get('v1/data/share/user/pageTotalUnused', {
          params: {
            keyword: this.dataShareObj.keyword,
            pageNum: this.dataShareObj.page,
            pageSize: this.dataShareObj.page === 1 ? 100 : 50
          }
        }).then(res => {
          if (!res.flag) {
            this.$swMessage.error(res.msg)
          }
          if (!res.data.length) {
            this.dataShareObj.hasMore = false
            return
          }
          const data = res.data.map(item => {
            return { title: item.name, value: item.id, describe: item.accountName, userName: `${item.name}|${item.id}|${item.accountName}|${item.organizationName}` }
          })
          if (this.dataShareObj.searchListFlag) {
            this.dataShareObj.searchListFlag = false
          }
          this.dataShareObj.list = this.dataShareObj.list.concat(data)
        }).finally(() => {
          this.dataShareObj.listLoading = false
        })
    },
    handleTransferChange () {

    },
    handleAdvancedSearch () {
      this.advancedDrawer.visible = true
      this.advancedDrawer.key++
    },
    confirmShare () {
      this.dataShareObj.dialogFlag = false
      this.$swMessage.success('分享成功')
    },
    refreshTable () {
      this.$nextTick(() => {
        this.tableKey++
      })
    },
    resetTableData () {
      this.getTableHeader()
    },
    handleTableTitle (title) {
      this.tableTitle = title.map(item => {
        return { prop: item.name, label: item.comment, type: item.type }
      })
      if (!this.tableTitle.length) {
        this.tableTitle = [{ prop: 'text', label: '暂无表头数据' }]
      }
      this.refreshTable()
    },
    getTableHeader () {
      this.tableLoading = true
      const params = {
        yyId: this.$route.query.yyid
      }
      service
        .get('/v1/table/tableHeader', {
          params
        })
        .then(res => {
          this.tableTitle = res.data.map(item => {
            return { prop: item.name, label: item.comment, type: item.type }
          })
          if (!this.tableTitle.length) {
            this.tableTitle = [{ prop: 'text', label: '暂无表头数据' }]
          }
          this.refreshTable()
          this.tableLoading = false
          if (this.condition) {
            this.getDataResult()
          } else {
            this.getTableData()
          }
        })
    },
    getTableData () {
      this.tableLoading = true
      const params = {
        createBy: this.applyName,
        startTime: this.applyTime ? this.applyTime[0] : '',
        endTime: this.applyTime ? this.applyTime[1] : '',
        yyId: this.$route.query.yyid,
        pageNum: this.page,
        pageSize: this.pageSize
      }
      service
        .get('/v1/table/tableData', {
          params
        })
        .then(res => {
          this.tableData = res.data.map(item => {
            for (const key in item) {
              if (!item[key]) {
                item[key] = '-'
              }
              if (key === 'createTime') {
                item[key] = parseTime(item[key])
              }
              if (!item['id']) {
                item['id'] = item.ffid
              }
            }
            return item
          })
          this.totalCount = res.count
          this.tableLoading = false
        })
    },
    openSonTable (scope) {
      const curSonKey = scope.item.prop
      this.dialogTableComment = scope.item.label
      const sonObjs = scope.row.son
      for (const key in sonObjs) {
        if (key === curSonKey) {
          this.dialogTableHeader = sonObjs[key].header
          this.dialogTableData = sonObjs[key].data
          break
        }
      }
      this.dialogTableVisible = true
    },
    openLink () {
      window.open('http://101.231.81.202:9820/#/data_service/api')
    },
    changePage (page) {
      this.page = page
      if (this.condition) {
        this.getDataResult(this.condition)
        return
      }
      this.getTableData()
    },
    changeSize (size) {
      this.pageSize = size
      if (this.condition) {
        this.getDataResult(this.condition)
        return
      }
      this.getTableData()
    },
    operationHandle (id, operation) {
      if (operation === 'delete') {
        this.deleteRow(id)
      } else if (operation === 'edit') {
        this.editRow(id)
      } else if (operation === 'details') {
        this.lookRow(id)
      }
    },
    deleteRow (id) {
      const arr = this.tableData.filter(item => {
        if (item.id === id) {
          return item.ffid
        }
      })
      var param = {
        ffid: arr[0].ffid,
        fid: this.$route.params.fid
        // this.$route.params.fid
      }
      this.$swConfirm('确认删除？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return service.get('/v1/supplement/delete', { params: param })
        })
        .then(res => {
          this.$swMessage.success(res.msg)
          this.getTableData()
        })
        .catch(res => {
          this.$swMessage.error(res.msg)
        })
    },
    editRow (id) {
      const data = this.tableData
      const len = data.length
      let ffid = ''
      for (let i = 0; i < len; i++) {
        if (data[i].id === id) {
          ffid = data[i].ffid
          break
        }
      }
      window.open(
        `${designFormUrl}/supply?fid=${this.$route.params.fid
        }&ffid=${ffid}&supply_line_id=${id}&from=adminplatform&dataType=supply&token=${localStorage.getItem('Admin-Token')}`,
        '_blank'
      )
    },
    lookRow (id) {
      const data = this.tableData
      const len = data.length
      let ffid = ''
      let taskid = ''
      let processInstanceId = ''
      for (let i = 0; i < len; i++) {
        if (data[i].id === id) {
          ffid = data[i].ffid
          taskid = data[i].taskId
          processInstanceId = data[i].processInstanceId
          break
        }
      }
      window.open(
        `${designFormUrl}/looking?fid=${this.$route.params.fid
        }&ffid=${ffid}&taskid=${taskid}&processInstanceId=${processInstanceId}&from=adminplatform&token=${localStorage.getItem('Admin-Token')}`,
        '_blank'
      )
    },
    handleAddData () {
      window.open(
        `${designFormUrl}/supply?yyid=${this.$route.query.yyid
        }&from=adminplatform&token=${localStorage.getItem('Admin-Token')}`,
        '_blank'
      )
    },

    handleExportClick () {
      this.excelVisible = true
    },
    handleExportConfirm () {
      const param = {}
      param.createBy = this.applyName
      param.startTime = this.applyTime[0]
      param.endTime = this.applyTime[1]
      param.yyId = this.$route.query.yyid
      let url = ''
      const keys = Object.keys(param)
      for (const key of keys) {
        if (param[key] || param[key] === 0 || param[key] === false) {
          url += `${encodeURIComponent(key)}=${encodeURIComponent(
            param[key]
          )}&`
        }
      }
      url = url.substring(0, url.length - 1)
      window.open(
        baseURL +
        `/v1/table/exportData?${url}&token=${localStorage.getItem(
          'Admin-Token'
        )}`,
        '_blank'
      )
      this.excelVisible = false
    }
  }
}
</script>
<style lang="scss">
.innerSearch {
  height: 100%;
  .dataView_advanceSearch {
    padding: 0;
    border: none;
    height: 100%;
  }
  .searchbtn {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: absolute;
    bottom: 0;
    width: 100%;
  }
}
</style>
<style lang="scss" scoped>
.sw-table-unpublish {
  font-size: 12px;
  color: #f5a623;
  line-height: 22px;
  &:before {
    width: 8px;
    height: 8px;
    background: #f5a623;
    border-radius: 4px;
    display: inline-block;
    content: "";
  }
}
.sw-table-closed {
  font-size: 12px;
  color: rgba(238, 84, 79, 1);
  line-height: 22px;
  &:before {
    width: 8px;
    height: 8px;
    background: rgba(238, 84, 79, 1);
    border-radius: 4px;
    display: inline-block;
    content: "";
  }
}
.remind-mes {
  display: inline-block;
  width: 30px !important;
  height: 14px !important;
  line-height: 14px;
  text-align: center;
  margin-left: 8px;
  white-space: nowrap;
  background: rgba(51, 148, 225, 1);
  color: rgba(255, 255, 255, 1);
  border-radius: 0px 26px 26px 0px;
}
.fs-10 {
  display: inline-block;
  font-size: 10px;
  -webkit-font-size: 12px;
  -webkit-transform: scale(0.8);
}
.bg-red {
  background: rgba(238, 84, 79, 1);
}
.fabu-dialog {
  overflow: scroll !important;
  max-height: calc(100vh - 200px) !important;
}
.font-grey {
  color: rgba(132, 144, 154, 1);
  font-size: 12px;
  width: 120px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  white-space: nowrap;
  text-align: right;
  padding-right: 20px;
}
</style>
